<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_allacciatura') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column">
        <b-field v-if="orderbool" horizontal :label="$translate('as_image') | capitalize">
          <b-checkbox v-model="asImage" :disabled="disabledbool"></b-checkbox>
        </b-field>
        <b-field
          v-if="orderbool"
          horizontal
          :label="$translate('allacciatura') | capitalize"
          :message="errors.first('allacciatura')"
          :type="{ 'is-danger': errors.has('allacciatura') }"
        >
          <b-select
            :disabled="asImage || disabledbool"
            v-validate="'required'"
            name="allacciatura"
            v-model="mod.allacciatura"
            :multiple="!orderbool"
          >
            <option v-for="allacc in availableallacc" :key="allacc.id" :value="allacc.id">
              {{ allacc.commercial_name }}
            </option>
          </b-select>
        </b-field>
        <b-field
          v-if="!orderbool"
          horizontal
          :label="$translate('allacciatura') | capitalize"
          :message="errors.first('available_allacci')"
          :type="{ 'is-danger': errors.has('available_allacci') }"
        >
          <b-select
            :disabled="asImage"
            v-validate="'required'"
            name="available_allacci"
            v-model="mod.allacci"
            :multiple="!orderbool"
          >
            <option v-for="allacc in availableallacc" :key="allacc.id" :value="allacc.id">
              {{ allacc.commercial_name }}
            </option>
          </b-select>
        </b-field>
        <b-field
          v-if="!orderbool"
          horizontal
          :label="$translate('allacciatura default') | capitalize"
          :message="errors.first('default_allacci')"
          :type="{ 'is-danger': errors.has('default_allacci') }"
        >
          <b-select
            v-validate="'required|included:' + mod.allacci"
            name="default_allacci"
            v-model="mod.allacci_default"
          >
            <option v-for="allacc in availableallacc" :key="allacc.id" :value="allacc.id">
              {{ allacc.commercial_name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <img :src="image" style="max-width: 150px; max-height: 150px;" />
      </div>
    </div>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/allacciatura'

export default {
  name: 'Allacciatura',
  props: ['mod', 'availableallacc', 'disabledbool', 'orderbool'],
  inject: ['$validator'],
  data() {
    return {
      asImage: null,
    }
  },
  computed: {
    image() {
      const allacciatura = this.availableallacc.find(allacciatura => {
        return allacciatura.id === this.mod.allacciatura
      })
      return allacciatura && allacciatura.variants ? allacciatura.variants[0].image : 'https://place-hold.it/150x150'
    },
  },
  watch: {
    asImage(newValue) {
      this.mod.allacciatura = newValue ? this.mod.allacci_default : null
    },
    mod: {
      handler() {
        if (this.mod.allacciatura && this.mod.allacciatura === this.mod.allacci_default) {
          this.asImage = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.mod.allacci = []
  },
}
</script>
<style scoped>
.container >>> .column select {
  min-width: 200px;
}
</style>
